import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { CoreModule } from "@tylertech/core-module";

import { FormDeliveryService, ReportDeliveryService } from "./services";

@NgModule({
    imports: [
        CoreModule
    ],
    providers: [
        FormDeliveryService,
        ReportDeliveryService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportingModule { }
